// components/ErrorBoundary.js - Error handling component
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Log error to your error reporting service
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.errorContainer}>
          <div style={styles.errorContent}>
            <h2 style={styles.errorTitle}>🚨 Something went wrong</h2>
            <p style={styles.errorMessage}>
              We're sorry, but something unexpected happened. Please try refreshing the page.
            </p>
            <button 
              style={styles.refreshButton}
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
            {process.env.NODE_ENV === 'development' && (
              <details style={styles.errorDetails}>
                <summary>Error Details (Development)</summary>
                <pre style={styles.errorStack}>
                  {this.state.error && this.state.error.toString()}
                  <br />
                  {this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    padding: '2rem'
  },
  errorContent: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    maxWidth: '500px'
  },
  errorTitle: {
    color: '#dc2626',
    marginBottom: '1rem'
  },
  errorMessage: {
    color: '#6b7280',
    marginBottom: '1.5rem',
    lineHeight: '1.6'
  },
  refreshButton: {
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    padding: '0.75rem 1.5rem',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1rem'
  },
  errorDetails: {
    marginTop: '1.5rem',
    textAlign: 'left'
  },
  errorStack: {
    backgroundColor: '#f3f4f6',
    padding: '1rem',
    borderRadius: '6px',
    fontSize: '0.8rem',
    overflow: 'auto'
  }
};

export default ErrorBoundary;
